import ProsCons from "./component";

export default ProsCons;